module.exports = __webpack_public_path__ + "img/IMG_4593.28ea9afa.jpg";